module.exports = __webpack_public_path__ + "static/media/nl.7e9f39db.ftl";